import { type User } from '@/models/domain/user'

interface SystemSelectionResult {
  selectedSystem: string | null
  needsSelection: boolean
}

export function determineSystemSelection(user: User): SystemSelectionResult {
  const userPreferenceKey = `system_preference_${user.email}`
  const previousSystem = localStorage.getItem(userPreferenceKey)

  if (previousSystem) {
    localStorage.setItem('selected_system', previousSystem)
    return {
      selectedSystem: previousSystem,
      needsSelection: false,
    }
  }

  if (user.systems?.length === 1) {
    const system = user.systems[0]
    localStorage.setItem('selected_system', system)
    localStorage.setItem(userPreferenceKey, system)
    return {
      selectedSystem: system,
      needsSelection: false,
    }
  }

  const needsSelection =
    user.sys_op || user.systems_all || (user.systems && user.systems.length > 1)

  return {
    selectedSystem: null,
    needsSelection: Boolean(needsSelection),
  }
}
